export const BROWSER = {
  WEBGL_CONTEXT_CREATION_ERROR: "webglcontextcreationerror",
  LOAD: "load",
  ERROR: "error",
  RESIZE: "resize",
  READY_STATE_CHANGE: "readystatechange",
  CAN_PLAY_THROUGH: "canplaythrough",
  LOADED_DATA: "loadeddata"
};
